module.exports = __webpack_public_path__ + "img/10.9.TU.a5e2a481.png";